<template>
<v-card >
  <v-list class="grey lighten-4" >
    <v-list-item >
      <v-list-item-avatar >
        <v-icon>mdi-map-marker</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{location.name}}</v-list-item-title>
        <v-list-item-subtitle >{{location.address}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-divider/>
  <!-- {{location}} -->
  <!-- hrs:|{{spaceId}}|{{practitioner}} -->
  <hours-view
    v-model="hours"
    :space-id="spaceId"
    :practitioner="practitioner"
    :location="location"
    @refresh="lookup" />
</v-card>
</template>
<script>
import HoursView from '@/views/space/operationhours/HoursView.vue'
export default {
  name: 'MemberLocationHours',
  components: {HoursView},
  props: {
    location: { type: Object, required: true },
    practitioner: { type: Object, required: true },
    spaceId: { type: [Number, String], required: true}
  },
  computed: {
    practitionerId () {
      let id = this.getObjectPath(this.practitioner, 'id')
      return this.getObjectPath(this.practitioner, 'user.id', id)
    },
    hours () {
      let hrs = this.getObjectPath(this.location, 'operation_hours', [])
      return hrs.find((hr) => {
        return hr.practitioner === this.practitionerId
      })
    }
  }
}
</script>